import clsx from "clsx";
import { FC } from "react";

import { PresentationBannerColorType } from "components/footer/PresentationBanner";

export type PillBannerColorType =
  | PresentationBannerColorType
  | "blue"
  | "dark-gray"
  | "dark-blue"
  | "hibiscus"
  | "moss";

interface PillBannerProps {
  className?: string;
  kind: PillBannerColorType;
  textChildren?: React.ReactNode;
  buttonChildren?: React.ReactNode;
  label?: string;
}

const KIND_CLASSES: Record<PillBannerColorType, string> = {
  black: "bg-green-shade-20 border border-green text-white",
  green: "bg-green-shade-20 border border-green text-white",
  "light-green": "bg-green-tint-90 border border-green-tint-90 text-green-shade-40",
  orange: "bg-orange border border-orange-tint-20 text-white",
  blue: "bg-blue-tint-93 border border-blue-tint-40 text-black-tint-20",
  "dark-blue": "bg-blue-shade-40 border border-blue text-white",
  "light-gray": "bg-black-tint-55 border border-black-tint-70 text-white",
  "dark-gray": "bg-black-tint-20 border border-black-tint-40 text-white",
  hibiscus: "bg-hibiscus-tint-95 border border-hibiscus-tint-55 text-black-tint-20",
  moss: "bg-moss-tint-95 border border-moss-tint-55 text-black-tint-20",
};

export const PillBanner: FC<PillBannerProps> = ({
  className,
  kind,
  label,
  textChildren,
  buttonChildren,
}) => {
  return (
    <div
      aria-label={label}
      className={clsx(
        "flex h-11 min-w-0 items-center justify-center gap-3 rounded-[1.5rem] pl-4 pr-1.5 text-sm font-medium",
        KIND_CLASSES[kind],
        className,
      )}
      role="status"
    >
      <div className="flex min-w-0 items-center justify-center gap-2">{textChildren}</div>
      <div className="flex items-center justify-center gap-1">{buttonChildren}</div>
    </div>
  );
};
